import RecordItemList from './RecordItemList';

export default RecordItemList;
